import { endOfDay, isPast } from 'date-fns';
import { LocaleUtils } from 'wix-style-react-tpa';

export const getFirstDayInMonth = (month) => {
  return new Date(month.getFullYear(), month.getMonth(), 1);
};

export const formatNarrowWeekDayName = (date, locale) => {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'narrow',
  }).format(date);
};

export const formatShortWeekDayName = (date, locale) => {
  const language = LocaleUtils.extractLanguageCode(locale);
  const weekdayIntlFormat = LocaleUtils.WEEKDAY_NARROW_FORMAT_LANGUAGES[
    language
  ]
    ? 'narrow'
    : 'short';

  return new Intl.DateTimeFormat(locale, {
    weekday: weekdayIntlFormat,
  }).format(date);
};

export const formatLongWeekDayName = (date, locale) => {
  return new Intl.DateTimeFormat(locale, {}).format(date);
};

export const formatDay = (date, locale) => {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

export const getFirstAvailableDate = ({
  startOfWeekDate,
  filterDate,
  excludePastDates,
}: {
  startOfWeekDate: Date;
  filterDate: (date: Date) => boolean;
  excludePastDates: boolean;
}): Date => {
  const currentDateToCheck = new Date(startOfWeekDate);
  for (let i = 0; i < 7; i++) {
    if (
      filterDate(currentDateToCheck) &&
      !(excludePastDates && isPast(endOfDay(currentDateToCheck)))
    ) {
      return currentDateToCheck;
    }
    currentDateToCheck.setDate(currentDateToCheck.getDate() + 1);
  }
  return startOfWeekDate;
};

export const formatDateForDataAttr = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
